import {LitElement, html, css, svg} from 'lit';
import {customElement, property} from 'lit/decorators.js';

@customElement('obi-chart-user-proposal')
export class ObiChartUserProposal extends LitElement {
  @property({type: Boolean}) useCssColor = false;

  private icon = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M2.10608 4.74025L8.5 2L15.5 4L21.2253 2.36421C21.8641 2.18169 22.5 2.66135 22.5 3.32573V11.7493C22.0733 11.1814 21.5679 10.676 21 10.2495V3.9886L16.25 5.34574V8.50409C15.7352 8.52095 15.2335 8.58969 14.75 8.70526V5.34574L9.25 3.77431V18.6786L2.89392 21.4026C2.23405 21.6854 1.5 21.2014 1.5 20.4835V5.6594C1.5 5.25937 1.7384 4.89783 2.10608 4.74025ZM3 5.98909L7.75 3.95338V17.6895L3 19.7252V5.98909Z" fill="currentColor"/>
<path d="M10.5 22.5V20.82C10.5 20.34 10.625 19.895 10.875 19.485C11.125 19.075 11.48 18.78 11.94 18.6C12.66 18.3 13.405 18.075 14.175 17.925C14.945 17.775 15.72 17.7 16.5 17.7C17.28 17.7 18.055 17.775 18.825 17.925C19.595 18.075 20.34 18.3 21.06 18.6C21.52 18.78 21.875 19.075 22.125 19.485C22.375 19.895 22.5 20.34 22.5 20.82V22.5H10.5ZM16.5 16.5C15.66 16.5 14.95 16.21 14.37 15.63C13.79 15.05 13.5 14.34 13.5 13.5C13.5 12.66 13.79 11.95 14.37 11.37C14.95 10.79 15.66 10.5 16.5 10.5C17.34 10.5 18.05 10.79 18.63 11.37C19.21 11.95 19.5 12.66 19.5 13.5C19.5 14.34 19.21 15.05 18.63 15.63C18.05 16.21 17.34 16.5 16.5 16.5Z" fill="currentColor"/>
</svg>
`;

  private iconCss = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M2.10608 4.74025L8.5 2L15.5 4L21.2253 2.36421C21.8641 2.18169 22.5 2.66135 22.5 3.32573V11.7493C22.0733 11.1814 21.5679 10.676 21 10.2495V3.9886L16.25 5.34574V8.50409C15.7352 8.52095 15.2335 8.58969 14.75 8.70526V5.34574L9.25 3.77431V18.6786L2.89392 21.4026C2.23405 21.6854 1.5 21.2014 1.5 20.4835V5.6594C1.5 5.25937 1.7384 4.89783 2.10608 4.74025ZM3 5.98909L7.75 3.95338V17.6895L3 19.7252V5.98909Z" style="fill: var(--element-active-color)"/>
<path d="M10.5 22.5V20.82C10.5 20.34 10.625 19.895 10.875 19.485C11.125 19.075 11.48 18.78 11.94 18.6C12.66 18.3 13.405 18.075 14.175 17.925C14.945 17.775 15.72 17.7 16.5 17.7C17.28 17.7 18.055 17.775 18.825 17.925C19.595 18.075 20.34 18.3 21.06 18.6C21.52 18.78 21.875 19.075 22.125 19.485C22.375 19.895 22.5 20.34 22.5 20.82V22.5H10.5ZM16.5 16.5C15.66 16.5 14.95 16.21 14.37 15.63C13.79 15.05 13.5 14.34 13.5 13.5C13.5 12.66 13.79 11.95 14.37 11.37C14.95 10.79 15.66 10.5 16.5 10.5C17.34 10.5 18.05 10.79 18.63 11.37C19.21 11.95 19.5 12.66 19.5 13.5C19.5 14.34 19.21 15.05 18.63 15.63C18.05 16.21 17.34 16.5 16.5 16.5Z" style="fill: var(--element-active-color)"/>
</svg>
`;

  override render() {
    return html`
      <div class="wrapper">${this.useCssColor ? this.iconCss : this.icon}</div>
    `;
  }

  static override styles = css`
    .wrapper {
      height: 100%;
      width: 100%;
      line-height: 0;
    }
    .wrapper > * {
      height: 100%;
      width: 100%;
    }
  `;
}

declare global {
  interface HTMLElementTagNameMap {
    'obi-chart-user-proposal': ObiChartUserProposal;
  }
}
